"use strict";

import { NgModule } from "@angular/core";
import { MovieDataService } from "./movie-data.service";

@NgModule({
  providers: [MovieDataService]
})
export class MovieDataModule {}
